import { ModifierGroup } from 'public/components/online_ordering/types'

/**
 * Determines if a modifier group requires SelectionList instead of a dropdown.
 * Returns true for groups that need the expanded list UI:
 * - Nested modifiers (handles modal flow for sub-modifiers)
 * - Duplicates allowed (needs quantity controls)
 * - Multi-select (maxSelections > 1 or null)
 */
export function requiresSelectionList(group: ModifierGroup): boolean {
  const hasNestedModifierGroups = group.modifiers.some(
    (modifier) => !!modifier.modifierGroups?.length
  )
  if (hasNestedModifierGroups) {
    return true
  }

  if (group.modifiers.some((modifier) => modifier.allowsDuplicates)) {
    return true
  }

  const { maxSelections } = group
  if (maxSelections != null && maxSelections > 1) {
    return true
  }

  if (maxSelections == null) {
    return true
  }

  return false
}
